"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DuplexBanner;
const react_1 = __importDefault(require("react"));
const Button_1 = require("@JohnLewisPartnership/jl-design-system/dist/elements/button/Button");
const styles = __importStar(require("./DuplexBanner.module.scss"));
const dispatchAnalytics_1 = require("../../../utils/dispatchAnalytics");
function DuplexBanner({ title, ctaText, ctaLink, clickUrl, impressionUrl, logoImage, description, desktopImage, accessibilityText, logoAccessibilityText, associatedAdvertId, }) {
    return (react_1.default.createElement("a", { href: ctaLink, className: styles.bannerLink, "data-testid": "nav-flyout-duplex-banner-link", onClick: () => {
            (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)({
                action: "kevel.clicked",
                type: "banner",
                adId: associatedAdvertId,
                clickUrl,
                impressionUrl,
            });
        } },
        react_1.default.createElement("img", { "data-testid": "nav-flyout-duplex-banner-image", src: `${desktopImage}?w=339&h=113&fmt=auto`, className: styles.image, alt: accessibilityText }),
        react_1.default.createElement("div", { className: styles.content },
            react_1.default.createElement("p", { "data-testid": "nav-flyout-duplex-banner-title", className: styles.title }, title.substring(0, 38)),
            description && (react_1.default.createElement("p", { "data-testid": "nav-flyout-duplex-banner-description", className: styles.description }, description.substring(0, 64)))),
        react_1.default.createElement("div", { className: styles.logoContainer },
            react_1.default.createElement("img", { src: logoImage, className: styles.logo, alt: logoAccessibilityText, "data-testid": "nav-flyout-duplex-banner-logo" })),
        react_1.default.createElement("div", { className: styles.ctaContainer },
            react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", className: styles.cta, "data-testid": "nav-flyout-duplex-banner-cta" }, ctaText))));
}
